import React from 'react'
import PortManagerContext from '../contexts/PortManagerContext'
/**
 * @returns PortManager
 * */
export default function usePortManager () {
  return React.useContext(PortManagerContext)
}